<template>
<label class="mui-textfield mui-textfield--float-label mui-textfield--no-underline mui-textfield--inherit-color mui-textfield--advanced-filters mui-textfield--label-gray pb-1 border-b border-neutral-300">
	<input type="number" :name="name" :value="value" @input="handleInput" @blur="$emit('blur')" ref="input"/>
	<label v-text="label"></label>
</label>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'AdvancedFiltersNumberInput',
  props: {
    name: String,
    label: String,
    value: [Number, String],
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    }
  },
  watch: {
    value() {
      Vue.nextTick(() => {
        this.$refs.input.dispatchEvent(new Event('change'))
      })
    }
  }
}
</script>